var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.getItems(),"label":_vm.label,"dense":"","solo":"","small":"","hide-details":"auto","disabled":_vm.disabled},on:{"input":_vm.changeValue},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }